import React, { Component } from 'react';
import loadScript from  'load-script';

//mobx
import { observer } from "mobx-react";

class AceEditor extends Component {
  aceReady(someVar) {
    window.ace_loaded=true;
    //window.ace.config.loadModule('ace/ext/emmet');
    this._editor = window.ace.edit(this._editorRef);

    this.updateAceProps(this.props);

    this._editor.on('focus', this.onFocus.bind(this));
    this._editor.on('blur', this.onBlur.bind(this));
    this._editor.on('copy', this.onCopy.bind(this));
    this._editor.on('paste', this.onPaste.bind(this));



    //this._editor.getSession().setMode("ace/mode/html");
    let newValue=typeof this.props.value === 'undefined'?'':this.props.value;
    this._editor.setValue(newValue);
    this._editor.session.selection.clearSelection();
    this._editor.on('change', this.onChange.bind(this));
    this._editor.renderer.on('afterRender', ()=>{
      if(this.props.afterRender) {
        this.props.afterRender();
      }
    });

  }
  onChange(event) {
    if(!this._silent) {
      this._silent=true;
      const value = this._editor.getValue();
      this.props.onChange(value, event);
      this._silent=false;
    }
  }
  onBlur() {

  }
  onCopy() {

  }
  onPaste() {

  }
  onFocus() {

  }
  componentWillReceiveProps(nextProps) {
    if (this._editor && this._editor.getValue() !== nextProps.value) {
      let newValue=typeof nextProps.value === 'undefined'?'':nextProps.value;

      // editor.setValue is a synchronous function call, change event is emitted before setValue return.
      this._silent = true;
      const pos = this._editor.session.selection.toJSON();
      //this._editor.setValue(nextProps.value, nextProps.cursorStart);
      this._editor.setValue(newValue);
      this._editor.session.selection.fromJSON(pos);
      this._silent = false;
    }
  }
  updateAceProps(newProps,oldProps={}) {
    //if(!this._silent) {
    if (newProps.setOptions) {
      for (let i in newProps.setOptions) {
        if (!oldProps.setOptions || (oldProps.setOptions && newProps.setOptions[i] !== oldProps.setOptions[i])) {
          this._editor.setOption(i, newProps.setOptions[i]);
        }
      }
    }

    if(newProps.editorProps) {
      for (let i in newProps.editorProps) {
        if (!oldProps.editorProps || (oldProps.editorProps && newProps.editorProps[i] !== oldProps.editorProps[i])) {
          this._editor[i]=newProps.editorProps[i];
        }
      }
    }

    if (newProps.mode !== oldProps.mode) {
        this._editor.getSession().setMode(`ace/mode/${newProps.mode}`);
    }

    if (newProps.showLineNumbers !== oldProps.showLineNumbers) {
      this._editor.renderer.setShowGutter(newProps.showLineNumbers);
    }

    if (newProps.theme !== oldProps.theme) {
      this._editor.setTheme(`ace/theme/${newProps.theme}`);
    }
    if (newProps.fontSize && newProps.fontSize !== oldProps.fontSize) {
      this._editor.setFontSize(newProps.fontSize);
    }

    if(newProps.fullScreen!==oldProps.fullscreen) {
      this._editor.resize();
    }

  }
  componentDidUpdate(oldProps) {
    if(window.ace_loaded) {
      this.updateAceProps(this.props, oldProps);
    }
  }

  componentDidMount() {
    if(!window.ace_loaded) {
      loadScript("/eva2/f/js/ace/emmet.js", ()=> {
        loadScript("https://cdnjs.cloudflare.com/ajax/libs/ace/1.2.9/ace.js", ()=> {
          loadScript("https://cdnjs.cloudflare.com/ajax/libs/ace/1.2.9/ext-emmet.js", ()=>{
            this.aceReady();//.bind(this)
});
        });
      });
    } else {
      this.aceReady();
    }
      //
    //});

    /*
    <script src="https://cdnjs.cloudflare.com/ajax/libs/ace/1.2.9/ext-emmet.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/ace/1.2.9/ace.js"></script>
    */

  }
  render() {
    return (
      <div ref={(ref)=>{ this._editorRef=ref; }} style={{ width:'100%'}} className="h100"></div>
    )
  }
}

function mapStateToProps(state) {
  return {

  }
}

export default observer(AceEditor);
